import React, { useEffect, useRef, useState } from "react";

export default function ProjectImage({ project, index }) {
  const imgRef = useRef(null);
  const [isLandscape, setIsLandscape] = useState(null);

  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete) {
      checkWidth();
    } else if (img) {
      img.onload = checkWidth;
    }

    function checkWidth() {
      if (img.naturalWidth > 1500) {
        setIsLandscape(true);
      } else {
        setIsLandscape(false);
      }
    }
  }, []);
  return (
    <img
      key={index}
      ref={imgRef}
      alt={isLandscape ? "landscape" : "portrait"}
      src={project.imageSrc}
      className={
        isLandscape === null ? "" : isLandscape ? "landscape" : "portrait"
      }
    />
  );
}
